import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-milestone-tracking-table',
  standalone: false,
  templateUrl: './milestone-tracking-table.component.html',
  styleUrls: ['./milestone-tracking-table.component.scss']
})
export class MilestoneTrackingTableComponent implements OnInit {
   @Input() milestoneData: any[] = [];
  @Input() loading: boolean = false;

  filteredMilestoneData: any[] = [];
  paginatedData: any[] = [];

  pageSize = 10;
  pageSizeOptions = [10, 25, 50, 100];

  currentPage = 1;
  totalPages = 0;

  startEntry = 0;
  endEntry = 0;

  sortField: string | null = null;
  sortOrder: 1 | -1 = 1;

   filters: any = {
    ser: '',
    challenge: '',
    firmDetails: '',
    ms_00: '',
    ms_01: '',
    ms_02: '',
    ms_03: '',
    ms_04: '',
    ms_05: ''
  };

  cols: any[] = [
    { field: 'ser', header: 'S. No.' },
    { field: 'challenge', header: 'Challenge' },
    { field: 'firmDetails', header: 'Firm Details' },
    { field: 'ms_00', header: 'MS 00' },
    { field: 'ms_01', header: 'MS 01' },
    { field: 'ms_02', header: 'MS 02' },
    { field: 'ms_03', header: 'MS 03' },
    { field: 'ms_04', header: 'MS 04' },
    { field: 'ms_05', header: 'MS 05' },
  ];

  // get filteredMilestoneData(): any[] {
  //   if (!this.milestoneData) {
  //     return [];
  //   }
  //   // Filter out any null, undefined, or empty items
  //   return this.milestoneData.filter(item => item != null && (item.challenge || item.firmDetails || item.ser));
  // }

  ngOnInit(): void {
    if (!this.milestoneData) {
      this.milestoneData = [];
    }
    this.filteredMilestoneData = [...this.milestoneData];
    // Default sort: S. No. ascending
    this.sortField = 'ser';
    this.sortOrder = 1;
    this.applySort();
    this.setupPagination();
  }

    ngOnChanges(): void {
    this.filteredMilestoneData = [...this.milestoneData];
    if (!this.sortField) {
      this.sortField = 'ser';
      this.sortOrder = 1;
    }
    this.applySort();
    this.setupPagination(); 
  }
   applyFilter() {

    this.filteredMilestoneData = this.milestoneData.filter(item => {

      return Object.keys(this.filters).every(key => {

        const searchValue = (this.filters[key] || '').toLowerCase();
        const dataValue = (item[key] || '').toString().toLowerCase();

        return dataValue.includes(searchValue);

      });

    });

    this.currentPage = 1;
    this.applySort();
    this.setupPagination();
  }

  toggleSort(field: string) {
    if (this.sortField === field) {
      this.sortOrder = this.sortOrder === 1 ? -1 : 1;
    } else {
      this.sortField = field;
      this.sortOrder = 1;
    }
    this.currentPage = 1;
    this.applySort();
    this.setupPagination();
  }

  getSortIcon(field: string): string {
    if (this.sortField !== field) return 'pi pi-sort';
    return this.sortOrder === 1 ? 'pi pi-sort-amount-up-alt' : 'pi pi-sort-amount-down';
  }

  private applySort(): void {
    if (!this.sortField) return;
    const field = this.sortField;
    const order = this.sortOrder;

    const toComparable = (v: any): { t: 'empty' | 'number' | 'date' | 'string'; v: any } => {
      if (v == null || v === '') return { t: 'empty', v: '' };
      if (typeof v === 'number' && Number.isFinite(v)) return { t: 'number', v };
      const s = String(v).trim();
      if (s === '' || s === '-') return { t: 'empty', v: '' };

      const n = Number(s.replace(/,/g, ''));
      if (Number.isFinite(n) && s.match(/^-?\d[\d,]*(\.\d+)?$/)) return { t: 'number', v: n };

      const d = new Date(s);
      if (!Number.isNaN(d.getTime())) return { t: 'date', v: d.getTime() };

      return { t: 'string', v: s.toLowerCase() };
    };

    const cmp = (a: any, b: any) => {
      const av = toComparable(a?.[field]);
      const bv = toComparable(b?.[field]);
      if (av.t === 'empty' && bv.t === 'empty') return 0;
      if (av.t === 'empty') return 1; // empties last
      if (bv.t === 'empty') return -1;
      if (av.t === bv.t) {
        if (av.v < bv.v) return -1;
        if (av.v > bv.v) return 1;
        return 0;
      }
      // Prefer number/date over string for mixed values
      const rank = (t: string) => (t === 'number' ? 0 : t === 'date' ? 1 : 2);
      return rank(av.t) - rank(bv.t);
    };

    this.filteredMilestoneData = [...this.filteredMilestoneData].sort((a, b) => order * cmp(a, b));
  }
   setupPagination() {

    this.totalPages = Math.ceil(this.filteredMilestoneData.length / this.pageSize);

    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;

    this.paginatedData = this.filteredMilestoneData.slice(start, end);

    this.startEntry = this.filteredMilestoneData.length ? start + 1 : 0;
    this.endEntry = Math.min(end, this.filteredMilestoneData.length);
  }

  changePage(page: number) {

    if (page < 1 || page > this.totalPages) return;

    this.currentPage = page;
    this.setupPagination();
  }
    changePageSize() {
    this.currentPage = 1;
    this.setupPagination();
  }

  get pages(): number[] {
    return Array.from({ length: this.totalPages }, (_, i) => i + 1);
  }


}

